var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVeganDiybathbomb = function SvgVeganDiybathbomb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 49.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 49.5,
    stroke: "#E2DFDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.7383 45.3574C85.7383 54.14 78.6186 61.2598 69.8359 61.2598C61.0533 61.2598 53.9336 54.14 53.9336 45.3574C53.9336 36.5748 61.0533 29.4551 69.8359 29.4551C78.6186 29.4551 85.7383 36.5748 85.7383 45.3574Z",
    fill: "#EFE5EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59 73.499C59.8284 73.499 60.5 72.8275 60.5 71.999V60.999C60.5 60.1706 61.1716 59.499 62.0001 59.499C62.8284 59.499 63.5 60.1705 63.5 60.999V71.999C63.5 72.8275 64.1716 73.499 65 73.499C65.8284 73.499 66.5 72.8275 66.5 71.999V60.999C66.5 58.5137 64.4853 56.499 62.0001 56.499C59.5149 56.499 57.5 58.5136 57.5 60.999V71.999C57.5 72.8275 58.1716 73.499 59 73.499Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5 67.333C57.5 68.1614 58.1716 68.833 59 68.833H65C65.8284 68.833 66.5 68.1614 66.5 67.333C66.5 66.5046 65.8284 65.833 65 65.833H59C58.1716 65.833 57.5 66.5046 57.5 67.333Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3831 73.4486C81.0405 73.2741 81.4981 72.679 81.4981 71.9989V57.9988C81.4981 57.1704 80.8265 56.4988 79.9981 56.4988C79.1697 56.4988 78.4981 57.1704 78.4981 57.9988V66.3506L73.3004 57.2546C72.963 56.6641 72.2704 56.3745 71.613 56.5491C70.9557 56.7236 70.498 57.3187 70.498 57.9988V71.9989C70.498 72.8273 71.1696 73.4989 71.998 73.4989C72.8265 73.4989 73.498 72.8273 73.498 71.9989V63.6472L78.6957 72.7431C79.0332 73.3336 79.7257 73.6232 80.3831 73.4486Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 71.999C32.5 72.8275 33.1716 73.499 34 73.499H40C40.8284 73.499 41.5 72.8275 41.5 71.999C41.5 71.1706 40.8284 70.499 40 70.499H35.5V59.499H40C40.8284 59.499 41.5 58.8274 41.5 57.999C41.5 57.1705 40.8284 56.499 40 56.499H34C33.1716 56.499 32.5 57.1705 32.5 57.999V71.999Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 65C32.5 65.8284 33.1716 66.5 34 66.5H38C38.8284 66.5 39.5 65.8284 39.5 65C39.5 64.1716 38.8284 63.5 38 63.5H34C33.1716 63.5 32.5 64.1716 32.5 65Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0005 73.499C24.6702 73.499 25.2588 73.0551 25.4428 72.4111L29.4427 58.411C29.6703 57.6145 29.2091 56.7843 28.4125 56.5567C27.616 56.3291 26.7857 56.7903 26.5582 57.5869L24.0005 66.539L21.4427 57.5869C21.2151 56.7903 20.3848 56.3291 19.5883 56.5567C18.7917 56.7843 18.3305 57.6145 18.5581 58.411L22.5582 72.4111C22.7422 73.0551 23.3308 73.499 24.0005 73.499Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5 70.499C47.3954 70.499 46.5 69.6037 46.5 68.4989V61.499C46.5 60.3944 47.3954 59.499 48.5 59.499H48.5013C49.605 59.499 50.5 60.3938 50.5 61.4978V61.499C50.5 62.3274 51.1715 62.999 52 62.999C52.8284 62.999 53.5 62.3274 53.5 61.499V61.4978C53.5 58.737 51.262 56.499 48.5013 56.499H48.5C45.7385 56.499 43.5 58.7375 43.5 61.499V68.4989C43.5 71.2604 45.7385 73.499 48.5 73.499C51.2615 73.499 53.5 71.2604 53.5 68.4989V66.999C53.5 66.1705 52.8284 65.499 52 65.499H50.25C49.4216 65.499 48.75 66.1705 48.75 66.999C48.75 67.8274 49.4216 68.499 50.25 68.499H50.5C50.4999 69.6038 49.6045 70.499 48.5 70.499Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5 20C26.5 32.9706 37.0294 43.5 50 43.5C50.8284 43.5 51.5 42.8284 51.5 42C51.5 29.0294 40.9706 18.5 28 18.5C27.1716 18.5 26.5 19.1716 26.5 20ZM48.4415 40.4415C47.6828 30.369 39.631 22.3172 29.5585 21.5585C30.3172 31.631 38.369 39.6828 48.4415 40.4415Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5 42C48.5 42.8284 49.1716 43.5 50 43.5C62.9706 43.5 73.5 32.9706 73.5 20C73.5 19.1716 72.8284 18.5 72 18.5C59.0294 18.5 48.5 29.0294 48.5 42ZM70.4415 21.5585C60.369 22.3172 52.3172 30.369 51.5585 40.4415C61.631 39.6828 69.6828 31.631 70.4415 21.5585Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 80C18.5 80.8284 19.1716 81.5 20 81.5H80.0001C80.8285 81.5 81.5001 80.8284 81.5001 80C81.5001 79.1716 80.8285 78.5 80.0001 78.5H20C19.1716 78.5 18.5 79.1716 18.5 80Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 50C18.5 50.8284 19.1716 51.5 20 51.5H80.0001C80.8285 51.5 81.5001 50.8284 81.5001 50C81.5001 49.1716 80.8285 48.5 80.0001 48.5H20C19.1716 48.5 18.5 49.1716 18.5 50Z",
    fill: "black"
  })));
};
export default SvgVeganDiybathbomb;